import { __rest } from '../../../../../../_virtual/_tslib.js';
import React from 'react';

var HelixIcon = function HelixIcon(_a) {
  var icon = _a.icon,
      className = _a.className,
      rest = __rest(_a, ["icon", "className"]);

  return React.createElement(React.Fragment, null, icon(Object.assign({
    className: className
  }, rest)));
};

export { HelixIcon as default };